import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, MenuItem
} from "@mui/material";

export default function RangeDialog({ open, onClose, onSave, editData }) {
  const [rangeData, setRangeData] = useState({
    reference: '',
    gender: '',
    limit: '',
    critical_limit: '',
    special_condition: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (editData) {
      setRangeData(editData);
    } else {
      setRangeData({
        reference: '',
        gender: '',
        limit: '',
        critical_limit: '',
        special_condition: ''
      });
    }
    setErrors({});
  }, [editData, open]);

  const handleChange = (field) => (e) => {
    setRangeData({ ...rangeData, [field]: e.target.value });
  };

  const validate = () => {
    let tempErrors = {};

    if (!rangeData.reference) {
      tempErrors.reference = "Reference is required";
    }
    if (!rangeData.gender) {
      tempErrors.gender = "Gender is required";
    }

    const hasAtLeastOne = rangeData.limit || rangeData.critical_limit || rangeData.special_condition;
    if (!hasAtLeastOne) {
      tempErrors.limit = "At least one of these three is required";
      tempErrors.critical_limit = "At least one of these three is required";
      tempErrors.special_condition = "At least one of these three is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSave = () => {
    if (validate()) {
      onSave(rangeData);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{editData ? 'Edit Test Range' : 'Add Test Range'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Reference"
          fullWidth
          value={rangeData.reference}
          onChange={handleChange('reference')}
          margin="normal"
          error={!!errors.reference}
          helperText={errors.reference}
        />
        <TextField
          label="Gender"
          select
          fullWidth
          value={rangeData.gender?.toLowerCase() || ""}
          onChange={handleChange('gender')}
          margin="normal"
          error={!!errors.gender}
          helperText={errors.gender}
        >
          <MenuItem value="male">Male</MenuItem>
          <MenuItem value="female">Female</MenuItem>
          <MenuItem value="both">Both</MenuItem>
        </TextField>
        <TextField
          label="Limit"
          fullWidth
          value={rangeData.limit}
          onChange={handleChange('limit')}
          margin="normal"
          error={!!errors.limit}
          helperText={errors.limit}
        />
        <TextField
          label="Critical Limit"
          fullWidth
          value={rangeData.critical_limit}
          onChange={handleChange('critical_limit')}
          margin="normal"
          error={!!errors.critical_limit}
          helperText={errors.critical_limit}
        />
        <TextField
          label="Special Condition"
          fullWidth
          multiline
          rows={3}
          value={rangeData.special_condition}
          onChange={handleChange('special_condition')}
          margin="normal"
          error={!!errors.special_condition}
          helperText={errors.special_condition}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
